module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"AQPS":"AQPS","DSA":"Half Arabian Blood","PS":"Thoroughbred","AR":"Arabian","AA":"Anglo-Arabian","DS":"Half Blood","TE":"Foreign trotter","TF":"French trotter"}}')
  delete Component.options._Ctor
}
